// Worst Sellers — legendary commercial disasters (seeded placeholders).
// Replace `productHandle` to point at any live Shopify product handle.
// If the handle isn't found in the products list, the section uses the
// fallback image instead so the layout never collapses.

export const WORST_SELLERS = [
  {
    id: "ws-001",
    productHandle: null,
    fallbackImage:
      "https://customer-assets.emergentagent.com/job_chaotic-threads/artifacts/ftkjlt0a_IMG_888E5426-CA59-42A3-8AAC-4B972FF01377.jpeg",
    fallbackName: "Wet Cabbage Skegness Cap",
    report: "Spotted on a red picnic bench. Has not moved since.",
    stat: "Confiscated at 2 boardwalks",
    classification: "Aggressively dad-energy",
  },
  {
    id: "ws-002",
    productHandle: null,
    fallbackImage:
      "https://customer-assets.emergentagent.com/job_chaotic-threads/artifacts/n9wq169g_IMG_888E5426-CA59-42A3-8AAC-4B972FF01377.jpeg",
    fallbackName: "Priority Boarding Survivor Dinghy",
    report: "Not seaworthy. Not legal. Strangely emotional.",
    stat: "Pre-orders: 0",
    classification: "Maritime hazard",
  },
  {
    id: "ws-003",
    productHandle: null,
    fallbackImage:
      "https://customer-assets.emergentagent.com/job_chaotic-threads/artifacts/tndnu98t_IMG_888E5426-CA59-42A3-8AAC-4B972FF01377.jpeg",
    fallbackName: "Ultra Damp Toilet Roll",
    report: "Confused absolutely everyone. Also: not absorbent.",
    stat: "Returns: 100%",
    classification: "Bathroom misconduct",
  },
  {
    id: "ws-004",
    productHandle: null,
    fallbackImage:
      "https://customer-assets.emergentagent.com/job_chaotic-threads/artifacts/ig2xohzt_IMG_888E5426-CA59-42A3-8AAC-4B972FF01377.jpeg",
    fallbackName: "Eau de Regret",
    report: "Notes of damp lettuce, late-night diner booth, and poor decisions.",
    stat: "Units shifted: 1",
    classification: "Olfactory hazard",
  },
];

// WC APPROVED attributes are now defined inline in /components/WCApproved.jsx
// (each attribute carries its own icon + tagline, not just a string).

// Damp Drops — limited release schedule placeholders (modular: replace with
// real Shopify collection handles or hand-curate per drop).
export const DAMP_DROPS = [
  {
    id: "dd-001",
    code: "Drop 001",
    name: "Walk of Shame",
    status: "Out now",
    statusTone: "live",
    blurb: "Three flip flops. One conscience. Limited to ankle level.",
    handle: "walk-of-shame",
  },
  {
    id: "dd-002",
    code: "Drop 002",
    name: "Brief Encounters",
    status: "Pieces remaining",
    statusTone: "warn",
    blurb: "Pants for the pathologically optimistic.",
    handle: "brief-encounters",
  },
  {
    id: "dd-003",
    code: "Drop 003",
    name: "Mildly Unacceptable",
    status: "Coming soon",
    statusTone: "soon",
    blurb: "Currently being shrugged at by focus groups.",
    handle: "mildly-unacceptable",
  },
];

// Deadpan rotating footer messages — picks one at random per page-load.
export const FOOTER_DISCLAIMERS = [
  "Probably not suitable for formal weddings.",
  "Luxury fashion for people yelled at during bag checks.",
  "All garments tested in light drizzle and one heavy downpour.",
  "Returns processed on the second Tuesday of any month containing the letter R.",
  "If found wandering, please return to the nearest closed mini golf course.",
  "Premium clothing for beautifully unserious people.",
  "Supporting underdogs since absolutely whenever.",
];

// Future Divisions — rotating subhead labels for the "Coming Soon" block.
// Treated like real fashion-house R&D divisions rather than empty placeholder.
export const FUTURE_DIVISION_LABELS = [
  "Moistwear Labs",
  "Future Divisions",
  "Under Investigation By Professionals",
  "Future Cabbage Projects",
];

// Brand-level rotating taglines used in marquees and footer rotating chips.
// Curated to reinforce the underdog positioning rather than scatter jokes.
export const BRAND_TAGLINES = [
  "Premium streetwear for modern leisure",
  "Premium clothing for beautifully unserious people",
  "Supporting the underdressed and overlooked",
  "Supporting underdogs since absolutely whenever",
  "Never picked first. Never cared.",
  "Fashion for gloriously average legends",
];
